import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useDragLayer} from 'react-dnd'
import {ItemSources} from "../ToolBarUtils/ItemSources";
import {Icon, Paper} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const getItemStyles = currentOffset => {
    if (!currentOffset) {
        return {
            display: 'none',
        };
    }
    const {x, y} = currentOffset;
    return {
        pointerEvents: 'none',
        position: 'fixed',
        zIndex: 9999,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        transform: `translate(${x}px, ${y}px)`,
        //top: y, left: x,
        // filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.45))',
    };
};


const DragLayerComponent = () => {
    const [ wait, done ] = useWait();
    const doneRef = useRef(done);
    useEffect(() => { doneRef.current = done });
    const collectedPropsRef = useRef();

     const {isDragging, item, currentOffset} = useDragLayer(monitor => {
        return {
            isDragging: monitor.isDragging(),
            item: monitor.getItem(),
            currentOffset: monitor.getClientOffset()
        }
    });

    //TODO increase performance
    //https://github.com/react-dnd/react-dnd/issues/421

    // collectedPropsRef.current = useDragLayer(monitor => {
    //     // Debounce if 'done' is false.
    //     // Since 'useDragLayer' doesn't honor it's dependencies
    //     // you need to use a ref to 'done' for it to catch a change in the value.
    //     if (!doneRef.current) {
    //         return collectedPropsRef.current;
    //     }
    //
    //     // This will keep 'doneRef.current' false and debounce
    //     // 'expensiveCollectFunction(monitor)' for 100 ms
    //     wait(5);
    //
    //     return {
    //         isDragging: monitor.isDragging(),
    //         item: monitor.getItem(),
    //         currentOffset: monitor.getClientOffset()
    //     }
    // });
    // const {isDragging, item, currentOffset} = collectedPropsRef.current;

    if (!isDragging) {
        return null
    }
    if(!item.type) {
        return null
    }
    return (
        <div style={getItemStyles(currentOffset)}>
            <RenderPreview type={item.type}/>
        </div>
    )
};

export default DragLayerComponent;


const RenderPreview = ({type}) => {
    const previewSource = useMemo(() => {
        return ItemSources.filter((i => i.type === type))[0] || {icon: "home", label: "Component"};
    }, [type])
    return (
        <Paper style={{
            width: 70,
            height: 60,
            textAlign: 'center',
            paddingTop: '5px',
            margin: '5px',
            border: '1px solid transparent',
        }}>
            <Icon>{previewSource.icon}</Icon>
            <Typography style={{fontSize: '0.8rem'}}>{previewSource.label}</Typography>
        </Paper>
    )
};

// Calling 'wait(millis)' will set 'done' to false
// and after 'millis' ms set 'done' to true.
function useWait() {
    const [ done, setDone ] = useState(true);
    const timeout = useRef();
    const wait = useCallback(millis => {
        clearTimeout(timeout.current);
        setDone(false);
        timeout.current = setTimeout(() => setDone(true), millis);
    }, []);
    return [ wait, done ];
}